'use client'

import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useModal } from '@/hooks/useModal'
import { AuthFormType, ModalType } from '@/constants/common.contant'
import { RegisterRequest, registerSchema } from '@/utils/schemas'
import { Input } from '../Input'
import { SubmitButton } from '../Buttons'
import { useAuth } from '@/hooks/useAuth'

interface RegisterFormProps {
  onFormSwitch: (formType: AuthFormType) => void
}

const RegisterForm = ({ onFormSwitch }: RegisterFormProps) => {
  const { closeModal } = useModal(ModalType.Auth)
  const { signup, isRegistering } = useAuth()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RegisterRequest>({
    resolver: zodResolver(registerSchema),
    defaultValues: {
      name: '',
      email: '',
      password: '',
      userType: 'admin',
    },
  })

  const onSubmit = async (data: RegisterRequest) => {
    try {
      await signup(data) // Gọi hàm đăng ký
      onFormSwitch(AuthFormType.Login)
    } catch (error) {
      throw Error('Đăng ký thất bại:' + error) // Log lỗi nếu cần
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <h2 className="text-2xl font-bold mb-4 text-center text-primary uppercase">ĐĂNG KÝ</h2>
      <Input
        label="Họ và tên"
        name="name"
        type="text"
        register={register}
        error={errors.name}
        placeholder="Nhập tên của bạn"
      />
      <Input
        label="Email đã đăng ký"
        name="email"
        type="email"
        register={register}
        error={errors.email}
        placeholder="Nhập email của bạn"
      />
      <Input
        label="Mật khẩu"
        name="password"
        type="password"
        register={register}
        error={errors.password}
        placeholder="Nhập mật khẩu của bạn"
      />
      <p className="">
        Bạn đã có tài khoản rồi?
        <button
          type="button"
          aria-label="login button"
          className="text-blue-500 underline ml-2"
          onClick={() => onFormSwitch(AuthFormType.Login)}
        >
          Đăng nhập
        </button>
      </p>
      <div className="flex items-center justify-around gap-6 border-t pt-6 mt-4">
        <button
          onClick={closeModal}
          type="button"
          aria-label="close button"
          className="w-[80%] bg-white text-black border uppercase py-2 rounded"
        >
          Đóng
        </button>
        <SubmitButton isLoading={isRegistering}>Đăng ký</SubmitButton>
      </div>
    </form>
  )
}

export default RegisterForm
